/**
 * Updates the document head's title, description, canonical, and social
 * preview tags in place, rather than creating new ones. `public/index.html`
 * already ships a full set of these tags (needed for the very first paint,
 * before any JS runs) - this just keeps them in sync with the current route,
 * client-side, and is also what the build-time prerenderer captures per
 * route (see scripts/prerender.js).
 *
 * og:type and the article:* tags vary by route (an "article" on a writeup,
 * "profile"/"website" elsewhere), and article:* only exist at all on
 * writeups - those go through setOrCreateMeta/removeMeta rather than
 * setMeta, since the static template can't pre-declare a tag that shouldn't
 * be there on most routes.
 */
const SITE_URL = 'https://brendenrunion.com';

function setMeta(selector, attr, content) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, content);
}

function setOrCreateMeta(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function removeMeta(property) {
  const el = document.querySelector(`meta[property="${property}"]`);
  if (el) el.remove();
}

export function updateHead({ title, description, path, ogType, article }) {
  const url = `${SITE_URL}${path}`;

  document.title = title;

  setMeta('meta[name="description"]', 'content', description);
  setMeta('link[rel="canonical"]', 'href', url);

  setOrCreateMeta('og:type', ogType || 'website');
  setMeta('meta[property="og:title"]', 'content', title);
  setMeta('meta[property="og:description"]', 'content', description);
  setMeta('meta[property="og:url"]', 'content', url);

  setMeta('meta[name="twitter:title"]', 'content', title);
  setMeta('meta[name="twitter:description"]', 'content', description);

  if (article) {
    setOrCreateMeta('article:published_time', article.publishedTime);
    setOrCreateMeta('article:author', article.author);
  } else {
    // Clean these up when navigating away from a writeup, since og:type
    // won't be "article" any more either.
    removeMeta('article:published_time');
    removeMeta('article:author');
  }
}

export default updateHead;
